import React from "react";
import i18n from "../../i18n";

import { Button, Menu, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";

import {
  authenticatedGetFetch,
  authenticatedGetFetchWithoutLoginRedirection,
} from "../../utils/AuthenticatedFetch";

export function serverLookup(force_update = false) {
  if (localStorage.getItem("serverLookup") !== null && !force_update) {
    return JSON.parse(localStorage.getItem("serverLookup"));
  } else {
    return new Promise((res, rej) => {
      if (localStorage.getItem("serverLookup") == null || force_update) {
        authenticatedGetFetchWithoutLoginRedirection(
          "/servers",
          (response) => {
            console.log(response);
            const lookup = {};
            for (const server of response)
              lookup[server.id] = server.id + " - " + server.name;
            lookup[0] = "";
            localStorage.setItem("serverLookup", JSON.stringify(lookup));
            res(lookup);
          },
          null,
          () => {
            res({});
          }
        );
      } else res(JSON.parse(localStorage.getItem("serverLookup")));
    });
  }
}

export default class ServerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      servers: [],
      selection: undefined,
    };
  }

  componentDidMount() {
    authenticatedGetFetch("/servers?filtered=true", (response) => {
      if (this.props.filter && typeof this.props.filter === "function")
        response = response.filter(this.props.filter);
      this.setState({ servers: response, selection: response[0] }, () =>
        this.props.onSelect(response[0].id, response[0])
      );
    });
  }

  render() {
    return (
      <div>
        <Select
          items={this.state.servers}
          itemRenderer={(item, { select, modifiers }) => {
            return (
              <MenuItem
                key={"srvcomp_" + item.id}
                label={item.id}
                text={item.name}
                onClick={() => {
                  this.props.onSelect(item.id, item);
                  this.setState({ selection: item });
                }}
              />
            );
          }}
          itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
            const renderedItems = items
              .map(renderItem)
              .filter(
                (item) =>
                  item != null &&
                  item.props.text != null &&
                  item.props.text.toUpperCase().includes(query.toUpperCase())
              );
            return (
              <Menu ulRef={itemsParentRef}>
                <MenuItem disabled={true} />
                {renderedItems}
              </Menu>
            );
          }}
        >
          <Button
            text={
              this.state.selection !== undefined
                ? `${this.state.selection.name} (${this.state.selection.ip})`
                : i18n.t("select a server")
            }
            rightIcon="double-caret-vertical"
          />
        </Select>
      </div>
    );
  }
}
